export { CommonService } from './../../shared/services/common-service';
export * from './staff.module';
export { StaffComponent } from './staff.component';


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/staff/index.ts